(function() {
  function applySort() {
    const sel = document.getElementById('UnitPriceSort');
    if (!sel || !sel.value) return;

    const asc  = sel.value === 'unit_price_asc';
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('li[data-unit-price]'));
    items.sort((a, b) => {
      const pa = parseFloat(a.dataset.unitPrice) || 0;
      const pb = parseFloat(b.dataset.unitPrice) || 0;
      return asc ? pa - pb : pb - pa;
    });
    items.forEach(i => grid.appendChild(i));
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sel = document.getElementById('UnitPriceSort');
    if (!sel) return;
    sel.addEventListener('change', applySort);
  });

  // Re-apply your sort after facets.js does its AJAX refresh:
  document.addEventListener('shopify:section:load', applySort);
})();
